export default function app(
  state = {
    cases: [],
    proposalHistory: [],
    oldProposals: [],
    currentCase: null,
    currentCaseComments: [],
    currentCaseDetails: [],
    filters: {},
    keyword: "",
    searchResults: {},
    signatures: []
  },
  action,
) {
  switch (action.type) {
    case "ADD_PROPOSAL_HISTORY":
      return { ...state, proposalHistory: [...action.payload] }
    case "ADD_CASES":
      return { ...state, cases: [...state.cases, ...action.payload] }
    case "ADD_SEARCH_RESULTS":
      return {
        ...state,
        searchResults: { ...state.searchResults, ...action.payload },
      }
    case "CHANGE_CURRENT_CASE":
      return { ...state, currentCase: { ...action.payload } }
    case "CHANGE_PROPOSAL_HISTORY":
      return { ...state, proposalHistory: [ ...action.payload ] }
    case "CHANGE_CURRENT_CASE_DETAILS":
      return { ...state, currentCaseDetails: { ...action.payload } }
    case "CHANGE_FILTERS":
      return { ...state, filters: [...action.payload] }
    case "CHANGE_KEYWORD":
      return { ...state, keyword: action.payload }
    case "CHANGE_OLD_PROPOSALS":
        return { ...state, oldProposals: [...action.payload] }
    case "CHANGE_SEARCH_RESULTS":
      return { ...state, searchResults: [...action.payload] }
    case "RESET_PROPOSAL_HISTORY":
      return { ...state, proposalHistory: [] }
    case "RESET_CASES":
      return { ...state, cases: [] }
    case "RESET_KEYWORD":
      return { ...state, keyword: "" }
    case "RESET_SEARCH_RESULTS":
      return { ...state, searchResults: {} }
    default:
      return state
  }
}
